<div class="dialog-select-languages" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <span>{{'言語選択' | translate }}</span>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="selectLanguages()">
          <mat-icon>add</mat-icon>
          <span>{{'選択' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="filter-field">
    <mat-form-field fxFlex="25%">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
    </mat-form-field>
  </div>

  <div mat-dialog-content fxLayout="column" fxLayoutAlign="start center">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> {{'No.' | translate }} </th>
        <td mat-cell *matCellDef="let language; let i = index">{{ (i + 1) + (paginator.pageSize * paginator.pageIndex)
          }}</td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
          <span>{{'全' | translate }}</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'言語コード' | translate
          }} </th>
        <td mat-cell *matCellDef="let language"> {{ language.lang_code }} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'名称' | translate
          }} </th>
        <td mat-cell *matCellDef="let language"> {{ currentLang == 'en' ?  (language.lang_name_en ? language.lang_name_en : (language.lang_name | translate)): language.lang_name }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator class="page" [pageSizeOptions]="[15, 30, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>


</div>